"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFieldFactory = void 0;
const errors_1 = require("../errors");
const base_1 = require("./base");
function numberFieldFactory(options) {
    options.checkType = (value) => {
        if (typeof value !== 'number') {
            throw new errors_1.ValidationError(`Field "${options.name}" must be number.`);
        }
        if (Number.isNaN(value)) {
            throw new errors_1.ValidationError(`Field "${options.name}" cannot be NaN`);
        }
    };
    return base_1.baseFieldFactory(options);
}
exports.numberFieldFactory = numberFieldFactory;
//# sourceMappingURL=number.js.map